import { useState } from 'react'

import { Event } from '@tribeplatform/gql-client/types'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Modal } from '@tribeplatform/react-ui-kit/Modal'

import { EventPicker } from '../../Event/index.js'
import { Form } from '../../Form/index.js'
import { T } from '../../i18n/components/T.js'

export const EventFormDialog = ({
  onSubmit,
  onClose,
  open,
}: {
  open?: boolean
  onSubmit: (id: string) => void
  onClose?: () => void
}) => {
  const [selectedEvent, setSelectedEvent] = useState<Event>(undefined)
  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Header
        title={
          <span className="flex items-center">
            <span className="flex items-center w-8 h-8 me-2">
              <SvgIcon name="calendar" />
            </span>
            <T
              id="Composer.EventFormDialog.HeaderTitle"
              defaultMessage="Embed event"
            />
          </span>
        }
      />
      <Modal.Content>
        <Form>
          <Form.Layout>
            <EventPicker value={selectedEvent} onChange={setSelectedEvent} />
            <Form.Actions>
              <Button
                type="submit"
                variant="primary"
                onClick={() => onSubmit(selectedEvent?.id)}
                disabled={!selectedEvent}
              >
                <T id="Generics.Embed" defaultMessage="Embed" />
              </Button>
              <Button variant="secondaryNeutral" onClick={onClose}>
                <T id="Generics.Cancel" defaultMessage="Cancel" />
              </Button>
            </Form.Actions>
          </Form.Layout>
        </Form>
      </Modal.Content>
    </Modal>
  )
}
